import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'Itemnotfoundreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			// totalRows:0,
			isLoadingforxls: false,
			csvFieldsForXls: {},
			listReportDataforxls: [],
			currentPage: 0,
			listStockReportData: [],
			listStockReportDatacsv: [],
			listStockReportFinalData: [],
			csvFields: [],
			// perPage: 10,
			// pageno: 0,
			// totalPage: 0,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			ProductID: '',
			isLoading: false,
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			fromdate: '',
			todate: '',
			orderid: '',
			rackid: '',
			user_type: '',
			nftype: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			limitExeed: false,
			recordLimit: 0,
			listMerchantData: [],
			MerchantList: [],
			merchantid: '',
			merchant: '',
			item: {},
			merchant: '',
			listMerchantData1: [],
			merchantList: [],
			merchantname: ''
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction();
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('editedjson.itemnotfoundreport');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		//this.getStockReportData();
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchant = item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getStockReportDataForXls(3)

		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},

		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},


		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.getMerchantList();
		// 		this.merchant = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.item = {}
		// 			this.merchant = '';

		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			// this.getStockReportData();
		// 		}
		// 	}
		// 	this.listStockReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getStockReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getStockReportSearch(csvCheck) {
			this.currentPage = 1;
			this.getStockReportData(2);
		},
		//to get client list
		getStockReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}


			this.isLoading = true;

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1);
			}

			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				merchantid: this.merchant,
				orderid: this.orderid,
				productid: this.ProductID,
				rackid: this.rackid,
				fromddate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				nftype: this.nftype
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'itemNotFoundReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
						this.listStockReportDataCsv = [];
						this.csvFields = {
							'orderid': this.$t('common.orderID'),
							'productid': this.$t('common.productId'),
							'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
							'productname': this.$t('printProductDetails.productName'),
							'mrp': this.$t('removeHold.productMrp'),
							'rackid': this.$t('notFoundReport.table.columns.nfRackID'),
							'nfqty': this.$t('notFoundReport.table.columns.nfQty'),
							'picktype': this.$t('notFoundReport.table.columns.pickingType'),
							'createdby': this.$t('notFoundReport.table.columns.nfUser'),
							'createddate': this.$t('notFoundReport.table.columns.nfDate'),
							'merchantname': this.$t('common.merchant'),
						};
						var dateFilter = [];
						var skipFilter = [];
						this.listStockReportDataCsv = result.data.data;
						csvHelper.data.jsonToCSV(this.$t('editedjson.itemnotfoundreport'), this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('ProductNotFoundReport', this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter);
					} else {
						this.listStockReportData = result.data.data;
						if (result.data.errorCode == -1 || result.data.errorCode == 1) {
							this.resultCount = 0;
							this.totalRows = 0;
						} else {
							this.totalRows = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count;
							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})

		},
		getStockReportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}



			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1);
			}


			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				orderid: this.orderid,
				productid: this.ProductID,
				merchantid: this.merchant,
				rackid: this.rackid,
				fromddate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				nftype: this.nftype
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'itemNotFoundReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('common.orderID')] =  'orderid',
								this.csvFieldsForXls[this.$t('common.productId')] =  'productid',
								this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] =  'eancode',
								this.csvFieldsForXls[this.$t('product.productName')] = 'productname',
								this.csvFieldsForXls[this.$t('product.table.columns.mrp')] =  'mrp',
								this.csvFieldsForXls[this.$t('notFoundReport.table.columns.nfRackID')]  = 'rackid',
								this.csvFieldsForXls[this.$t('notFoundReport.table.columns.nfQty')] = 'nfqty',
								this.csvFieldsForXls[this.$t('notFoundReport.table.columns.pickingType')] =  'picktype',
								this.csvFieldsForXls[this.$t('notFoundReport.table.columns.nfUser')] =  'createdby',
								this.csvFieldsForXls[this.$t('notFoundReport.table.columns.nfDate')] =  'createddate',
								this.csvFieldsForXls[this.$t('common.merchant')]  =  'merchantname'


							this.listReportDataforxls = result.data.data;
						}
						else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error);
				})
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getStockReportData()
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.item = {}
			this.show = false;
			this.download = true;
			this.ProductID = '';
			this.orderid = '';
			this.rackid = '';
			this.pageno = 0;
			this.merchant = '';
			this.totalRows = 0;
			this.nftype = '';
			this.listStockReportData = [];
			this.fromdate = '';
			this.todate = '';
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantlistArray = [];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.merchantPlaceholder')
						}];
						result.data.forEach(function (item) {
							merchantlistArray[item.merchantid] = item.merchantname;

						})
						this.merchantList = merchantlistArray;
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})
					}
				}, error => {
					console.error(error)
				})
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/itemnotfoundreport/itemnotfoundreport.component.js